import axios from "axios";

export default {
    getPublic: async function() {
        return await axios
            .get("/api/settings/get_public")
            .then(response => response.data);
    }
};
